var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfluencingPresence(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1182 -932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1238.93 957.2C1242.23 955.925 1245.08 954.275 1247.55 952.55 1242.98 948.05 1237.05 944.9 1230.38 944.075 1233.08 946.925 1236.45 951.425 1238.93 957.2Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.3 959.525C1230.9 959.45 1234.2 958.775 1237.13 957.8 1234.2 951.2 1230.15 946.4 1227.45 943.775L1227.23 943.775Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.3 961.475 1227.3 972.575 1240.58 972.575C1240.43 967.775 1239.38 963.425 1237.88 959.6 1234.65 960.65 1231.13 961.325 1227.3 961.475Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.82 953.9C1246.27 955.775 1243.12 957.575 1239.6 958.925 1241.17 962.9 1242.22 967.475 1242.37 972.575L1256.32 972.575C1256.1 965.375 1253.32 958.925 1248.82 953.9Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.42 959.525 1225.42 943.775 1225.2 943.775C1222.5 946.475 1218.45 951.275 1215.52 957.801 1218.52 958.775 1221.82 959.451 1225.42 959.526Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.42 986.224 1225.42 974.449 1212.07 974.449 1212.07 974.599C1212.15 979.624 1213.2 984.199 1214.7 988.099 1217.92 987.049 1221.52 986.299 1225.42 986.224Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.07 972.576 1225.35 972.576 1225.35 961.476C1221.52 961.401 1218 960.651 1214.77 959.601 1213.35 963.351 1212.3 967.776 1212.07 972.576Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.73 957.2C1216.28 951.425 1219.65 947 1222.35 944 1215.68 944.9 1209.68 947.975 1205.18 952.475 1207.58 954.2 1210.43 955.85 1213.73 957.2Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.42 988.101C1221.82 988.176 1218.45 988.851 1215.45 989.826 1218.22 996.277 1222.2 1001.08 1224.9 1003.85L1225.42 1003.85Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.65 990.501C1210.43 991.776 1207.58 993.426 1205.18 995.151 1209.68 999.651 1215.83 1003.03 1222.43 1003.93 1219.73 1000.93 1216.05 996.201 1213.65 990.501Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.2 972.576C1210.35 967.476 1211.47 962.901 1212.97 958.926 1209.45 957.576 1206.37 955.776 1203.75 953.901 1199.32 958.926 1196.55 965.451 1196.17 972.576Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.2 974.6 1210.2 974.45 1196.25 974.45C1196.4 981.8 1199.25 988.55 1203.83 993.725 1206.38 991.925 1209.45 990.125 1212.9 988.7 1211.33 984.65 1210.27 979.85 1210.2 974.6Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.25 997.325C1229.25 994.025 1230.3 991.025 1232.03 988.55 1230.53 988.325 1228.95 988.1 1227.3 988.1L1227.3 1003.93 1227.83 1003.93C1228.43 1003.25 1229.18 1002.5 1229.93 1001.68 1229.48 1000.25 1229.25 998.825 1229.25 997.326Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244.55 982.024C1248.15 982.024 1251.45 983.299 1254.07 985.399 1255.5 982.024 1256.32 978.349 1256.4 974.524L1242.52 974.524 1242.52 974.674C1242.45 977.374 1242.15 979.924 1241.7 982.399 1242.6 982.099 1243.57 982.024 1244.55 982.024Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.53 982.851C1240.13 980.301 1240.5 977.526 1240.58 974.601L1240.58 974.451 1227.3 974.451 1227.3 986.225C1229.4 986.301 1231.43 986.525 1233.38 986.901 1235.1 985.101 1237.2 983.675 1239.53 982.85Z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.07 1012.1 1254.97 1004.08C1256.4 1001.98 1257.22 999.501 1257.22 996.801 1257.22 989.676 1251.45 983.901 1244.32 983.901 1237.2 983.901 1231.42 989.676 1231.42 996.801 1231.42 1003.93 1237.2 1009.7 1244.32 1009.7 1247.02 1009.7 1249.5 1008.88 1251.6 1007.45L1259.62 1015.48C1260.52 1016.38 1262.1 1016.38 1263 1015.48 1263.97 1014.58 1263.97 1013.08 1263.07 1012.1ZM1244.02 988.176C1245.82 988.176 1247.32 989.676 1247.32 991.476 1247.32 993.276 1245.82 994.776 1244.02 994.776 1242.22 994.776 1240.72 993.276 1240.72 991.476 1240.72 989.676 1242.22 988.176 1244.02 988.176ZM1236.97 1002.73 1236.97 1000.63C1236.97 997.851 1239.22 995.601 1242 995.601L1245.75 995.601C1248.52 995.601 1250.77 997.851 1250.77 1000.63L1250.77 1002.73Z",
    fill: "#262626"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfluencingPresence);
export default __webpack_public_path__ + "static/media/influencingPresence.5d9b0d4431c3850edeae2ebb5b630ccd.svg";
export { ForwardRef as ReactComponent };